import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Login.css";

function Login() {
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  function handleSubmit(e) {
    e.preventDefault();
    setCarregando(true);
    setErro("");

    // Simula um pequeno delay(como se fosse uma requisição)
    setTimeout(() => {
      const resultado = login(usuario, senha);

      if (resultado.sucesso) {
        navigate("/admin");
      } else {
        setErro(resultado.mensagem);
      }
      setCarregando(false);
    }, 500);
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Login</h1>

        {erro && <div className="erro-mensagem">{erro}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="usuario">Usuário</label>
            <input
              id="usuario"
              type="text"
              placeholder="Digite seu usuário"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              disabled={carregando}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="senha">Senha</label>
            <input
              id="senha"
              type="password"
              placeholder="Digite sua senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              disabled={carregando}
              required
            />
          </div>

          <button type="submit" disabled={carregando} className="btn-login">
            {carregando ? "Entrando..." : "Entrar"}
          </button>
        </form>

      </div>
    </div>
  );
}

export default Login;
